export default __webpack_public_path__ + "static/media/actividad-16b.2c6864fc.mp3";